import { useState } from "react";

const links = [
  { id: "manifesto", target: "manifesto", label: "Manifesto" },
  { id: "craft", target: "craft", label: "Craft" },
  { id: "casework", target: "selected-work", label: "Work" },
  { id: "reel", target: "reel", label: "Reel" },
  { id: "beyond", target: "beyond-the-brief", label: "Beyond" },
  { id: "journey", target: "works", label: "Journey" },
  { id: "resume", target: "resume", label: "Resume" },
  { id: "armory", target: "armory", label: "Armory" },
  { id: "contact", target: "contact", label: "Contact" },
];

function Navigation({ activeSection }) {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header" data-testid="portfolio-header">
      <div className="header-inner">
        <a className="brand-mark" href="#top" data-testid="brand-monogram-link" aria-label="Back to top">
          <span>AM</span><i>/</i>
        </a>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {links.map((link) => (
            <a key={link.id} className={activeSection === link.id ? "is-active" : ""} href={`#${link.target}`} data-testid={`nav-link-${link.id}`}>
              {link.label}
            </a>
          ))}
        </nav>
        <a className="header-cta" href="#contact" data-testid="nav-initiate-dialogue-btn">Start a conversation <span>↗</span></a>
        <button className="mobile-nav-toggle" type="button" aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen((value) => !value)} data-testid="mobile-nav-toggle-btn">
          <span>{open ? "Close" : "Menu"}</span><b>{open ? "×" : "＋"}</b>
        </button>
      </div>
      {open && (
        <nav id="mobile-navigation" className="mobile-nav-panel" aria-label="Mobile navigation">
          {links.map((link) => (
            <a key={link.id} href={`#${link.target}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${link.id}`}>{link.label}<span>↗</span></a>
          ))}
        </nav>
      )}
    </header>
  );
}

export default Navigation;
